import { useState } from 'react';
import './Agendamento.css';

const AgendamentoServico = ({ onSelectServices, onBack, services = [] }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedIds, setSelectedIds] = useState([]);
    const [activeCategory, setActiveCategory] = useState('Todos');

    const categories = ['Todos', 'Cabelo', 'Barba', 'Combos', 'SPA & Química', 'Geral'];

    const toggleService = (service) => {
        if (selectedIds.includes(service.id)) {
            setSelectedIds(selectedIds.filter(id => id !== service.id));
        } else {
            setSelectedIds([...selectedIds, service.id]);
        }
    };

    const filteredServices = services.filter(service => {
        const matchesSearch = service.name.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesCategory = activeCategory === 'Todos' || service.category === activeCategory;
        return matchesSearch && matchesCategory;
    });

    const activeSelectedServices = services.filter(s => selectedIds.includes(s.id));

    const totalPrice = activeSelectedServices.reduce((total, s) => {
        const val = parseFloat(s.price.replace('R$ ', '').replace(',', '.'));
        return total + val;
    }, 0);

    return (
        <>
            <div className="booking-container fade-in">
                <h2 className="booking-title">Selecione os Serviços</h2>
                <p className="booking-subtitle">Compareça com 20 min de antecedência.</p>

                <div className="search-tabs-container">
                    <div className="search-container">
                        <input
                            type="text"
                            placeholder="Buscar serviço..."
                            className="search-input"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>

                    <div className="category-tabs">
                        {categories.map(cat => (
                            <button
                                key={cat}
                                className={`category-tab ${activeCategory === cat ? 'active' : ''}`}
                                onClick={() => setActiveCategory(cat)}
                            >
                                {cat}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="services-menu-list">
                    {categories.filter(cat => cat !== 'Todos').map(category => {
                        const categoryServices = filteredServices.filter(s =>
                            category === 'Geral' ? (!s.category || s.category === 'Geral') : s.category === category
                        );

                        if (categoryServices.length === 0) return null;

                        return (
                            <div key={category} className="menu-category-section">
                                <h3 className="menu-category-title">{category}</h3>
                                <div className="menu-items-grid">
                                    {categoryServices.map((service) => {
                                        const isSelected = selectedIds.includes(service.id);
                                        return (
                                            <div
                                                key={service.id}
                                                className={`menu-service-item ${isSelected ? 'selected' : ''}`}
                                                onClick={() => toggleService(service)}
                                            >
                                                <div className="item-badge-area">
                                                    <div className={`add-indicator ${isSelected ? 'active' : ''}`}>
                                                        {isSelected ? '✓' : '+'}
                                                    </div>
                                                </div>
                                                <div className="item-main-info">
                                                    <h4 className="item-title">{service.name}</h4>
                                                    <p className="item-desc">{service.duration}</p>
                                                </div>
                                                <div className="item-price-area">
                                                    <span className="item-price">{service.price}</span>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        );
                    })}

                    {filteredServices.length === 0 && (
                        <p className="no-results">Nenhum serviço encontrado.</p>
                    )}
                </div>

                <div className="action-buttons">
                    <button className="back-button" onClick={onBack}>Voltar</button>
                </div>
            </div>

            {selectedIds.length > 0 && (
                <div className="multi-service-footer">
                    <div className="selection-info">
                        <span>{selectedIds.length} selecionado(s)</span>
                        <strong>Total: R$ {totalPrice.toFixed(2).replace('.', ',')}</strong>
                    </div>
                    <button
                        className="continue-button"
                        onClick={() => onSelectServices(activeSelectedServices)}
                    >
                        CONTINUAR
                    </button>
                </div>
            )}
        </>
    );
};

export default AgendamentoServico;
